import Image1 from '@hotjar/shared-assets/images/integrations/analytics/HotjarxAnalytics-ID.gif';
import Image2 from '@hotjar/shared-assets/images/integrations/analytics/HotjarxAnalytics-events.gif';
import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const googleAnalytics: Integration = {
  slug: 'google-analytics',
  icon: 'google_analytics',
  name: 'integrations:google_analytics.title',
  tokenName: IntegrationTokenName.GoogleAnalytics,
  provider: 'integrations:card.hotjar',
  actionLabel: {
    useEventsTitle: 'integrations:details.header.google-analytics-use-events-title',
    useEventsCopy: 'integrations:details.header.google-analytics-use-events-copy',
    useUserIdsTitle: 'integrations:details.header.google-analytics-use-user-ids-title',
    useUserIdsCopy: 'integrations:details.header.google-analytics-use-user-ids-copy',
  },
  description: 'integrations:google_analytics.description-revamp',
  descriptionLarge: 'integrations:google_analytics.description-large',
  noticeTitle: 'integrations:google_analytics.notice-title',
  noticeDescription: 'integrations:google_analytics.notice-description',
  resources: [
    {
      copy: 'integrations:google_analytics.key-benefits',
      url: 'https://www.hotjar.com/integrations/google-analytics/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:google_analytics.using-with-hotjar',
      url: '/articles/8547713037719',
      icon: 'page_full',
    },
    {
      copy: 'integrations:google_analytics.tutorial',
      url: 'https://www.youtube.com/watch?v=N-4vsdfZAtQ',
      icon: 'recordings_old',
    },
    {
      copy: 'integrations:google_analytics.custom-dimensions',
      url: 'https://support.google.com/analytics/answer/2709829?hl=en#zippy=%2Cin-this-article',
      icon: 'page_full',
    },
  ],
  images: [Image1, Image2],
  videoUrl: 'https://www.youtube.com/embed/N-4vsdfZAtQ',
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
};
